<template>
  <div class="flex gap-4">
    <div
      class="flex bg-EXPONDO-white text-EXPONDO-black items-center h-11.5 border rounded p-2 gap-2"
    >
      <img
        :src="flagPath"
        class="h-6"
      >
      <span>
        {{ $t(label) }}
      </span>
    </div>
    <div class="flex">
      <CustomSelect
        :value="activeLanguageAndCountry"
        @input="changeLanguage"
      >
        <SelectOption
          v-for="languageAndCountry in languageAndCountries"
          :key="languageAndCountry"
          :value="languageAndCountry"
          :selected="languageAndCountry === activeLanguageAndCountry"
        >
          {{ $t(languageAndCountry) }}
        </SelectOption>
      </CustomSelect>
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'LanguageSelector',

  props: {
    flagPath: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    activeLanguageAndCountry: {
      type: String,
      default: '',
    },
    languageAndCountries: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  emits: ['changeLanguage'],
  setup(_, { emit }) {

    const changeLanguage = (value: string): void => {

      emit('changeLanguage', value);

    };

    return {
      changeLanguage,
    };

  },
});


</script>
